import axios from "axios";
import { ErrorMessage, Formik } from "formik";
import { useEffect, useRef, useState } from "react";
import Accordion from "react-bootstrap/Accordion";
import { useHistory, useParams } from "react-router-dom";
import { date, number, object, ref, string } from "yup";
import dateFormat from "dateformat";
import Hn from "../../../../../components/common/Hn";
import "./createFaceTraining.css";
import Participant from "./participantSession";
import UniteApprentissage from "./UniteApprentissage";
const uri = process.env.REACT_APP_BASE_URL;
let headers = {
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
};

var dte = new Date();
console.log("dte",dte)
const validationSchema = object().shape({
  ref: string().required("Champ obligatoire."),
  dateStart: date().default(() => new Date()),
  dateEnd: date().default(() => new Date()),
 // location: string().required("Champ obligatoire."),
  // seat_capacity_min: number().required("Champ obligatoire."),
  seat_capacity_min: number()
    .max(
      ref("seat_capacity_max"),
      "Must be less than Capacité d'acccueil maxinale"
    ),
    //.required("Champ obligatoire."),
  seat_capacity_max: number()
    .min(
      ref("seat_capacity_min"),
      "Must be more than Capacité d'acccueil minimale  "
    ),
    //.required("Champ obligatoire.")
 // former: string().required("Champ obligatoire."),
});

function CreateFaceSession() {
  const params = useParams();

  const fileRef = useRef();
  const [modalShow, setModalShow] = useState(false);
  const [lieuFormation, setLieuForamtion] = useState([]);
  const [formateurs, setForamteurs] = useState([]);
  const [sessions, setSessions] = useState([]);
  const [newSession, setNewSession] = useState([]);
  const [showUnit, setshowUnit] = useState(false);
  const [showSessions, setShowSessions] = useState(false);
  const [participe, setParticipe] = useState([]);
  const [changeListformer, setChangeListformer] = useState(true);

  const onHandelStatus = (touched, error, value) => {
    if (error && touched) {
      return "danger";
    } else if (value) {
      return "info";
    } else {
      return "warning";
    }
  };
  const uri = process.env.REACT_APP_BASE_URL;
//récupérer les formateurs extérieurs ou intérieurs
  function getformer(type) {
    let url = "/former";
    if (type) {
      url = "/former/organize/" + type;
    }

    axios
      .get(uri + url)
      .then((result) => {
        setForamteurs(result?.data);
      })
      .catch((err) => {
        console.log("err formateurs", err);
      });
  }
  //récupérer les sessions
  function getSessions() {
    axios
      .get(uri + "/training/" + params.id)
      .then((result) => {
        setSessions(result?.data.sessions);
      })
      .catch((err) => {
        console.log("err sessions", err);
      });
  }
  //si on choisit un type bien déterminé ca me donne sa liste de tous les noms et les prénoms des formateurs à choisir
  function ChangeList(value) {
    setChangeListformer(false);
    getformer(value);
  }
  useEffect(() => {
    getSessions();
    getformer("");
    axios
      .get(uri + "/location")
      .then((result) => {
        setLieuForamtion(result?.data);
      })
      .catch((err) => {
        console.log("err location", err);
      });
  }, []);

  let history = useHistory();

  //créer une nouvelle session
  const handleSubmit = async (values) => {
    const dateend = dateFormat(values.dateStart, "dd/mm/yyyy");
    const datedeb = new Date(values.dateEnd);
    // setnbUnit(diffdate(dateend, datedeb));
    if (params) {
      values.training_id = params.id;
    }
    
    await axios
      .post(`${uri}/session/new`, values, headers)
      .then((response) => {
     
        getSessionById(response.data.id);
        localStorage.setItem('idsession', response.data.id)
        setshowUnit(true);
        getSessions();
      })
      .catch((error) => {
        console.log(error);
      });

    // history.push('/admin/create-session-formation-apprendre');
  };
  //récupérer une session par id
  function getSessionById(id) {
    let url = "/session/" +id;
   
    axios
      .get(uri + url, headers)
      .then((result) => {
        setNewSession(result?.data);
      })
      .catch((err) => {
        console.log("err session by id", err);
      });
  }
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="container lists p-5">
          <nav aria-label="breadcrumb pb-3">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <a href="#">Formations présentielles - Actions de formation</a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Créer une action de formation
              </li>
            </ol>
          </nav>
          <div className="h-100 p-5 text-white bg-dark rounded-3">
            <Hn
              title="Créer une action de formation"
              level="h4"
              className="h4-size"
              plus={false}
            />
            <Hn
              title="Etape 2 : créer une session de formation"
              level="p"
              className="py-2 fw-bold"
              plus={false}
            />
            {showSessions
              ? Object.values(sessions).map((session, index) => (
                  <Accordion key={index}>
                    <Accordion.Item eventKey={session?.ref}>
                      <Accordion.Header>
                        {/* {setnbUnit(diffdate(new Date(session.dateEnd), new Date(session.dateStart)} */}
                        <span className="header-text"></span>

                        <p className="accordion-info">
                          Du {new Date(session?.dateStart).toLocaleDateString()}{" "}
                          au {new Date(session?.dateEnd).toLocaleDateString()}
                          <span>{session?.location?.address}</span>
                          <br></br>
                          <span>
                            {session?.former?.firstName}{" "}
                            {session?.former?.lastName}
                          </span>
                        </p>
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="row g-3">
                          <div className="col-md-4">
                            <label className="form-label">Référence*</label>
                            <p className="header-text">{session?.ref}</p>
                          </div>
                          <div className="col-md-4">
                            <label className="form-label">Date de début</label>
                            <p className="header-text">
                              {new Date(
                                session?.dateStart
                              ).toLocaleDateString()}
                            </p>
                          </div>
                          <div className="col-md-4">
                            <label className="form-label">Date de fin</label>
                            <p className="header-text">
                              {new Date(session?.dateEnd).toLocaleDateString()}
                            </p>
                          </div>

                          <div className="col-md-4">
                            <label className="form-label">
                              Lieu de formation
                            </label>
                            <p className="header-text">
                              {session?.location?.address}
                            </p>
                          </div>

                          <div className="col-md-4">
                            <label className="form-label">Formateurs</label>
                         
                         
                            <p className="header-text">
                              {" "}
                              {session?.former?.organize}{" "}
                            </p>
                          </div>
                          <div className="col-md-4">
                            <label className="form-label">&nbsp;</label>
                            <p className="header-text">
                              {session?.former?.firstName}{" "}
                              {session?.former?.lastName}
                            </p>
                          </div>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                ))
              : ""}
            <div className="form-elements mt-2">
              <div className="form-aria p-4">
                <Formik
                  initialValues={{
                    ref: "",
                    dateStart: new Date(dte).toISOString().split("T")[0],
                    dateEnd: "",
                    location: "",
                    seat_capacity_min: "",
                    seat_capacity_max: "",
                    former: "",
                    training: params.id,
                  }}
                  validationSchema={validationSchema}
                  onSubmit={handleSubmit}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                    /* and other goodies */
                  }) => (
                    <form className="row g-3" onSubmit={handleSubmit}>
                      <div className="col-md-4">
                        <label className="form-label">Référence*</label>
                        <input
                          status={onHandelStatus(
                            touched.ref,
                            errors.ref,
                            values.ref
                          )}
                          type="text"
                          className="form-control"
                          id="ref"
                          placeholder="Référence"
                          onChange={handleChange("ref")}
                          value={values.ref}
                          onBlur={handleBlur("ref")}
                          errors={errors.ref}
                        />
                        <ErrorMessage name="ref">
                          {(msg) => <div className="text-danger">{msg}</div>}
                        </ErrorMessage>
                      </div>
                      <div className="col-md-4">
                        <label className="form-label">Date de début</label>
                        <input
                          status={onHandelStatus(
                            touched.dateStart,
                            errors.dateStart,
                            values.dateStart
                          )}
                          type="date"
                          className="form-control"
                          id="dateStart"
                          placeholder="Date de début"
                          min={new Date(dte).toISOString().split("T")[0]}
                          max={values.dateEnd}
                          onChange={handleChange("dateStart")}
                          value={values.dateStart}
                          onBlur={handleBlur("dateStart")}
                          errors={errors.dateStart}
                        />

                        <input type="hidden" value={params.id} />

                        <ErrorMessage name="dateStart">
                          {(msg) => <div className="text-danger">{msg}</div>}
                        </ErrorMessage>
                      </div>
                      <div className="col-md-4">
                        <label className="form-label">Date de fin</label>
                        <input
                          status={onHandelStatus(
                            touched.dateEnd,
                            errors.dateEnd,
                            values.dateEnd
                          )}
                          type="date"
                          className="form-control"
                          id="dateEnd"
                          placeholder="Date de fin"
                          onChange={handleChange("dateEnd")}
                          value={values.dateEnd}
                          min={values.dateStart}
                          onBlur={handleBlur("dateEnd")}
                          errors={errors.dateEnd}
                        />
                        <ErrorMessage name="dateEnd">
                          {(msg) => <div className="text-danger">{msg}</div>}
                        </ErrorMessage>
                      </div>

                      <div className="col-md-4">
                        <label className="form-label">Lieu de formation</label>
                        <select
                          status={onHandelStatus(
                            touched.location,
                            errors.location,
                            values.location
                          )}
                          className="form-select"
                          aria-label="Default select example"
                          id="actif"
                          defaultValue={"sélectinner dans la liste"}
                          onChange={handleChange("location")}
                          value={values.location}
                          onBlur={handleBlur("location")}
                          errors={errors.location}
                        >
                          <option>sélectionner dans la liste</option>
                          {lieuFormation.map((lieu, i) => {
                            return (
                              <option value={lieu.id}  key={i}>{lieu?.address}</option>
                            );
                          })}
                        </select>
                        <ErrorMessage name="location">
                          {(msg) => <div className="text-danger">{msg}</div>}
                        </ErrorMessage>
                      </div>
                      <div className="col-md-4">
                        <label className="form-label">
                          Capacité d'acccueil minimale
                        </label>
                        <input
                          status={onHandelStatus(
                            touched.seat_capacity_min,
                            errors.seat_capacity_min,
                            values.seat_capacity_min
                          )}
                          type="number"
                          className="form-control"
                          id="seat_capacity_min"
                          // max={values.seat_capacity_max}
                          placeholder="00"
                          onChange={handleChange("seat_capacity_min")}
                          value={values.seat_capacity_min}
                          onBlur={handleBlur("seat_capacity_min")}
                          errors={errors.seat_capacity_min}
                        />
                        <ErrorMessage name="seat_capacity_min">
                          {(msg) => <div className="text-danger">{msg}</div>}
                        </ErrorMessage>
                      </div>
                      <div className="col-md-4">
                        <label className="form-label">
                          Capacité d'acccueil maximale*
                        </label>
                        <input
                          status={onHandelStatus(
                            touched.seat_capacity_max,
                            errors.seat_capacity_max,
                            values.seat_capacity_max
                          )}
                          type="number"
                          className="form-control"
                          id="seat_capacity_max"
                          placeholder="00"
                          //min={values.seat_capacity_min}
                          onChange={handleChange("seat_capacity_max")}
                          value={values.seat_capacity_max}
                          onBlur={handleBlur("seat_capacity_max")}
                          errors={errors.seat_capacity_max}
                        />
                        <ErrorMessage name="seat_capacity_max">
                          {(msg) => <div className="text-danger">{msg}</div>}
                        </ErrorMessage>
                      </div>

                      <div className="col-md-4">
                        <label className="form-label">Formateur</label>
                        <select
                          className="form-select"
                          aria-label="Default select example"
                          id="actif"
                          defaultValue={"sélectinner dans la liste"}
                          onChange={(event) => ChangeList(event.target.value)}
                        >
                          <option value="">sélectionner dans la liste</option>
                          <option value="interne">Interne</option>
                          <option value="externe">Externe</option>
                        </select>
                      </div>
                      <div className="col-md-4">
                        <label className="form-label">&nbsp;</label>
                        <select
                          className="form-select"
                          aria-label="Default select example"
                          id="former"
                          value={values.former}
                          onChange={handleChange("former")}
                          onBlur={handleBlur("former")}
                          errors={errors.former}
                          disabled={changeListformer}
                        >
                          <option defaultValue>
                            sélectionner dans la liste
                          </option>
                          {formateurs.map((former, i) => {
                            return (
                              <option value={former.id}  key={i}>
                                {former?.lastName}
                              </option>
                            );
                          })}
                        </select>
                      </div>

                      <div className="col-12 mt-5">
                        <button
                          //href="/admin/create-session-formation-apprendre"
                          type="submit"
                          className="btn btn-outline-primary float-end"
                        >
                          Valider
                        </button>
                      </div>
                    </form>
                  )}
                </Formik>
                {showUnit ? (
                  <div className="row pt-5">
                      {newSession?.lessons?.map((item, index) => {
                        return (<>
                          <UniteApprentissage 
                          session={newSession} nbUnite={index} former={formateurs} lieuFormation={lieuFormation}
                          ind={item.id}
                          lesson={item}
                          key={index}
                          />
                        </>)
                      })}
                      {newSession.id ? 
                      <Participant
                        setParticipe={setParticipe}
                        participe={participe}
                        sessions={newSession?.id}
                      />
                      :''}
                  </div>
                ) : (
                  ""
                )}
              </div>
              <div className="col-12 mt-5">
                <a
                  href="/admin/create-formation-presentielle"
                  className="btn btn-link text-decoration-none resetBtn"
                >
                  Annuler
                </a>
                <button
                  type="submit"
                  className="btn btn-primary float-end"
                  onClick={() => {
                    history.push("/admin/createSession-etape3/" + params.id);
                  }}
                >
                  Suivant
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* lists */}
      </div>
    </div>
  );
}

export default CreateFaceSession;
